export const ScrapIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g opacity="0.5">
        <path
          d="M21.6639 4H10.1494C7.85685 4 6 5.82886 6 8.08685V25.1699C6 27.3972 8.51037 28.7458 10.4191 27.5504L16 24.0971L21.5809 27.5504C23.5 28.7458 26 27.3768 26 25.1392V8.08685C26 5.82886 24.1432 4 21.8506 4H21.6639Z"
          fill="#FFC61C"
        />
      </g>
    </svg>
  );
};

export const HighLightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M6.17834 23.29L4.25071 25.3303C3.81543 25.7919 3.96645 26.5766 4.55273 26.8167L7.20878 27.9337C7.54633 28.0722 7.92831 27.9891 8.17703 27.7214L9.30519 26.5212L6.17834 23.29Z"
        fill="#EB3F3F"
      />
      <path
        d="M27.4076 9.05406L25.249 6.82916L23.0904 4.60425C22.3264 3.8103 21.0828 3.8103 20.3188 4.60425L7.60713 17.7506C7.50054 17.8614 7.4117 17.9814 7.34952 18.1199L5.75057 21.5449C5.50184 22.0711 5.60844 22.6989 6.00818 23.1144L7.59825 24.7577L7.91804 25.0808L9.50811 26.7241C9.90785 27.1395 10.5119 27.2411 11.0271 26.9918L14.3405 25.33C14.4738 25.2654 14.5981 25.1731 14.7047 25.0623L27.4253 11.916C28.1893 11.122 28.1893 9.83878 27.4253 9.04483L27.4076 9.05406Z"
        fill="#FFC9C9"
      />
      <path
        d="M23.1019 4.59546L27.4102 9.05451C28.1742 9.84846 28.1742 11.1317 27.4102 11.9257L24.8075 14.6122L17.7188 7.28197L20.3215 4.59546C21.0854 3.80151 22.3291 3.80151 23.093 4.59546H23.1019Z"
        fill="#EB3F3F"
      />
      <path
        d="M26.6274 24.9707H19.0857C18.3351 24.9707 17.7266 25.6031 17.7266 26.3832V26.3924C17.7266 27.1725 18.3351 27.8049 19.0857 27.8049H26.6274C27.378 27.8049 27.9865 27.1725 27.9865 26.3924V26.3832C27.9865 25.6031 27.378 24.9707 26.6274 24.9707Z"
        fill="#EB3F3F"
      />
    </svg>
  );
};

export const AlarmIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M15.9993 29.0002C18.9653 29.0002 21.3696 26.5307 21.3696 23.4845C21.3696 20.4382 18.9653 17.9688 15.9993 17.9688C13.0333 17.9688 10.6289 20.4382 10.6289 23.4845C10.6289 26.5307 13.0333 29.0002 15.9993 29.0002Z"
        fill="#FF8A00"
      />
      <path
        d="M16.0019 8.72C17.5411 8.72 18.7889 7.43954 18.7889 5.86C18.7889 4.28047 17.5411 3 16.0019 3C14.4626 3 13.2148 4.28047 13.2148 5.86C13.2148 7.43954 14.4626 8.72 16.0019 8.72Z"
        fill="#FFC61C"
      />
      <path
        d="M16.0003 5.49805C21.2966 5.49805 25.6021 9.80662 25.6021 15.1273V25.4716H6.39844V15.1273C6.39844 9.80662 10.704 5.49805 16.0003 5.49805Z"
        fill="#FFC61C"
      />
      <path
        d="M26.5278 21.5156H5.47222C4.38299 21.5156 3.5 22.3991 3.5 23.4888C3.5 24.5786 4.38299 25.4621 5.47222 25.4621H26.5278C27.617 25.4621 28.5 24.5786 28.5 23.4888C28.5 22.3991 27.617 21.5156 26.5278 21.5156Z"
        fill="#FFC61C"
      />
    </svg>
  );
};
